import StringUtil from "../../core/util/StringUtil";
import {PropertyType} from "../../core/decorators/PropertyType";
import ColorUtil from "../../core/util/ColorUtil";
import {AbstractPropertyType} from "../../core/util/property/AbstractPropertyType";
import IPropertyRecord from "../../core/util/property/IPropertyRecord";
import {ICssProperty} from "./CssPropertyProvider";
import {ILayout} from "../form/fields/layout/ILayoutType";
import {FragmentList, FragmentProvider} from "../../core/components/FragmentProvider";
import {IFragmentLayoutConfig} from "../../core/components/FragmentLayout";
import {Card} from "@blueprintjs/core";

type V = ILayout<IFragmentLayoutConfig>;

@PropertyType({name: "layout", label: "Layout"})
export default class FragmentLayoutPropertyType extends AbstractPropertyType<V, V> {

	public getDefaultValue() {
		return null;
	}

	public getValue(layout: V): ILayout {
		return layout;
	}

	public getInput(value: V, onChange: (value: V) => void,  wrapper?: IPropertyRecord<V>, args?: FragmentList<any>) {
		return (
			FragmentProvider.getLayoutInputComponent(args)
		);
	}

	public getPreviewElement(value: V, minimal: boolean, wrapper: IPropertyRecord<V>) {
		return (
			<Card style={{padding: "5px"}}>
				<pre>
					{JSON.stringify(value)}
				</pre>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/theme/LayoutProperty.type.tsx